import './Style.css';

import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';

function Menu({ coData, showLiveAnalyticsOnly }) {
  const { t } = useTranslation();
  const { pageid } = useParams();

  const pageList = [
    { title: t('MN001'), active: '', url: 'live-analytics' },
    // {title: 'Usage Statistics', active: '', url: 'usage-statistics'},
    { title: t('MN002'), active: '', url: 'engagement-resources' },
    {
      title: t('MN003'),
      active: '',
      url: 'campaigns-communications',
    },
    {
      title: t('MN004'),
      active: '',
      url: 'health-wellbeing-strategy',
    },
    { title: t('MN005'), active: '', url: 'partners-providers' },
    { title: t('MN006'), active: '', url: 'leadership-lab' },
  ];

  if (coData && coData.erv === 'yes') {
    pageList.push({
      title: t('MN007'),
      active: '',
      url: 'erv-import',
    });
  }

  const menuItems = showLiveAnalyticsOnly
    ? pageList.filter((page) => page.url === 'live-analytics')
    : pageList;

  return (
    <div id="side_nav">
      <ul className="vertical-nav">
        {menuItems.map((page) => {
          return (
            <li key={page.title} className={pageid === page.url ? 'active' : ''}>
              <Link
                to={`/company-report/${page.url}`}
                exact
                onClick={(e) => {
                  if (showLiveAnalyticsOnly) {
                    e.preventDefault();
                  }
                }}
              >
                <span>{page.title}</span>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
export default Menu;
